<template>
  <div class="text-title">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>